import { useState, useEffect, useRef } from 'react';
import { Typography, LinearProgressBar } from '@coolremote/shared';
import { t } from 'ttag';
import styles from './DiscoveryProgress.module.css';

/** Discovery polling window, in seconds - kept in sync with the poll timeout in the dialog. */
export const DISCOVERY_DURATION_IN_SECONDS = 60;

const TICK_IN_MS = 500;

/**
 * Progress block shown while BACnet discovery is running.
 * The bar fills linearly over the discovery window.
 *
 * @returns {React.ReactElement}
 */
const DiscoveryProgress = () => {
  const [progress, setProgress] = useState(0);
  const startedAtRef = useRef(Date.now());

  useEffect(() => {
    const totalInMs = DISCOVERY_DURATION_IN_SECONDS * 1000;

    const intervalId = setInterval(() => {
      const elapsed = Date.now() - startedAtRef.current;
      setProgress(Math.min(100, (elapsed / totalInMs) * 100));
    }, TICK_IN_MS);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className={styles.container}>
      <Typography className={styles.title}>
        {t`Discovering devices...`}
      </Typography>

      <LinearProgressBar value={progress} height={8} />
    </div>
  );
};

export default DiscoveryProgress;
